function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.059.854l17.62 31.344c.64 1.139-.16 2.562-1.44 2.562H1.999c-1.28 0-2.08-1.423-1.44-2.562L18.177.854a1.641 1.641 0 012.88 0"
});

function SvgTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 35"
  }, props), _ref);
}

export default SvgTriangle;